import ManualTotpNextButton from '../../components/enroll-manual-push/ManualTotpNextButton';
import SecretKeyInstructionsClassic from '../../components/enroll-manual-push/SecretKeyInstructionsClassic';
import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';
import ProxyFooter from '../../components/common/ProxyFooter';

export default class EnrollManualPushCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;

  async shouldCustomize() {
    return [ 'enroll-manual-push' ].includes(this.context?.controller);
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }): React.JSX.Element {
    return (
      <ProxyFooter
        text={this.footerText}
        footerLinks={footerLink.not('[data-se=cancel]')}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpManualSetup::Landing`);
    this.hideOktaVerifyEmailOption();
    super.forgifyController();
    this.forgifyManualTotpNextButton();
    this.forgifySecretKeyInstructionsText();
    this.replaceComponents();
  }

  protected hideOktaVerifyEmailOption() {
    jQueryCourage('li:contains("Send activation link via email")').remove();
    jQueryCourage('option:contains("Send activation link via email")').remove();
  }

  private forgifyManualTotpNextButton() {
    const buttonContainer = jQueryCourage('[data-type="next-button-wrap"]');
    if (buttonContainer.length) {
      const parentContainer = buttonContainer.parent();
      if (parentContainer.length) {
        const forgeComponent = <ManualTotpNextButton container={parentContainer} />;
        this.renderForgeAndHideOktaComponent({
          id: 'manual-totp-next-button',
          oktaComponent: parentContainer,
          forgeComponent: forgeComponent,
        });
      }
    }
  }

  private forgifySecretKeyInstructionsText() {
    const oktaSecretKeyInstructions: JQuery<HTMLElement> = jQueryCourage('.secret-key-instructions');
    if (oktaSecretKeyInstructions.length) {
      const forgeComponent = <SecretKeyInstructionsClassic container={oktaSecretKeyInstructions} />;
      this.renderForgeAndHideOktaComponent({
        id: oktaSecretKeyInstructions.attr('class')!,
        oktaComponent: oktaSecretKeyInstructions,
        forgeComponent: forgeComponent,
      });
    }
  }
}
